import * as actionTypes from "../actions/actionTypes";

// MARK: - State structure
const initialState = {
  token: null,
  isAuthenticated: null,
  authError: null,
  loading: false,
  requiresTwoFactor: false,
  twoFactorUserId: null
}


// MARK: - Reducer
const authReducer = (state = initialState, action) => {

  switch (action.type) {
    case actionTypes.AUTH_START: return {...initialState, isAuthenticated: false, loading: true}
    case actionTypes.AUTH_SUCCESS: return {...initialState, token: action.token, username: action.username, isAuthenticated: true}
    case actionTypes.AUTH_FAIL: return {...initialState, isAuthenticated: false, authError: action.error, requiresTwoFactor: state.requiresTwoFactor, twoFactorUserId: state.twoFactorUserId}
    case actionTypes.AUTH_LOGOUT: return {...initialState, isAuthenticated: false}
    case actionTypes.AUTH_REQUIRES_2FA: return {...initialState, isAuthenticated: false, requiresTwoFactor: true, twoFactorUserId: action.userId}
    case actionTypes.AUTH_2FA_START: return {...state, loading: true, authError: null}
    case actionTypes.AUTH_2FA_CANCEL: return {...initialState, isAuthenticated: false}
    default: return state;
  }
}

export default authReducer
